// extracted by mini-css-extract-plugin
export default {"frompeopleContainer":"QMessage_frompeopleContainer__FyhzW","frompeopleTextContainer":"QMessage_frompeopleTextContainer__S0u6m"};